/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { DeletedItem } from '../models/deleted-item';
import { FolderCreationResponse } from '../models/folder-creation-response';
import { mediaControllerDeleteFile } from '../fn/file-manager/media-controller-delete-file';
import { MediaControllerDeleteFile$Params } from '../fn/file-manager/media-controller-delete-file';
import { mediaControllerDownload } from '../fn/file-manager/media-controller-download';
import { MediaControllerDownload$Params } from '../fn/file-manager/media-controller-download';
import { mediaControllerGetLinkToFile } from '../fn/file-manager/media-controller-get-link-to-file';
import { MediaControllerGetLinkToFile$Params } from '../fn/file-manager/media-controller-get-link-to-file';
import { mediaControllerGetUrl } from '../fn/file-manager/media-controller-get-url';
import { MediaControllerGetUrl$Params } from '../fn/file-manager/media-controller-get-url';
import { mediaControllerListFilesAndFolders } from '../fn/file-manager/media-controller-list-files-and-folders';
import { MediaControllerListFilesAndFolders$Params } from '../fn/file-manager/media-controller-list-files-and-folders';
import { mediaControllerListFolders } from '../fn/file-manager/media-controller-list-folders';
import { MediaControllerListFolders$Params } from '../fn/file-manager/media-controller-list-folders';
import { mediaControllerMakeDir } from '../fn/file-manager/media-controller-make-dir';
import { MediaControllerMakeDir$Params } from '../fn/file-manager/media-controller-make-dir';
import { mediaControllerMoveFile } from '../fn/file-manager/media-controller-move-file';
import { MediaControllerMoveFile$Params } from '../fn/file-manager/media-controller-move-file';
import { mediaControllerRecentFilesAndFolders } from '../fn/file-manager/media-controller-recent-files-and-folders';
import { MediaControllerRecentFilesAndFolders$Params } from '../fn/file-manager/media-controller-recent-files-and-folders';
import { mediaControllerStatsFilesAndFolders } from '../fn/file-manager/media-controller-stats-files-and-folders';
import { MediaControllerStatsFilesAndFolders$Params } from '../fn/file-manager/media-controller-stats-files-and-folders';
import { mediaControllerUploadFile } from '../fn/file-manager/media-controller-upload-file';
import { MediaControllerUploadFile$Params } from '../fn/file-manager/media-controller-upload-file';
import { MediaLinkResponse } from '../models/media-link-response';
import { MediaListFullResponse } from '../models/media-list-full-response';
import { MediaListPrefixResponse } from '../models/media-list-prefix-response';
import { MediaRecentListFullResponse } from '../models/media-recent-list-full-response';
import { MediaStatsFullResponse } from '../models/media-stats-full-response';
import { MediaUrlResponse } from '../models/media-url-response';
import { MovedItem } from '../models/moved-item';
import { UploadedItem } from '../models/uploaded-item';

@Injectable({ providedIn: 'root' })
export class FileManagerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mediaControllerStatsFilesAndFolders()` */
  static readonly MediaControllerStatsFilesAndFoldersPath = '/file-manager/stats';

  /**
   * Restituisce le metriche dei media nel bucket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerStatsFilesAndFolders()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerStatsFilesAndFolders$Response(params?: MediaControllerStatsFilesAndFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaStatsFullResponse;
}>> {
    const obs = mediaControllerStatsFilesAndFolders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce le metriche dei media nel bucket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerStatsFilesAndFolders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerStatsFilesAndFolders(params?: MediaControllerStatsFilesAndFolders$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaStatsFullResponse;
}> {
    const resp = this.mediaControllerStatsFilesAndFolders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaStatsFullResponse;
}>): BaseResponse & {
'data'?: MediaStatsFullResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerRecentFilesAndFolders()` */
  static readonly MediaControllerRecentFilesAndFoldersPath = '/file-manager/recents';

  /**
   * Restituisce l'elenco dei media più recenti nel bucket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerRecentFilesAndFolders()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerRecentFilesAndFolders$Response(params?: MediaControllerRecentFilesAndFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaRecentListFullResponse;
}>> {
    const obs = mediaControllerRecentFilesAndFolders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco dei media più recenti nel bucket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerRecentFilesAndFolders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerRecentFilesAndFolders(params?: MediaControllerRecentFilesAndFolders$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaRecentListFullResponse;
}> {
    const resp = this.mediaControllerRecentFilesAndFolders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaRecentListFullResponse;
}>): BaseResponse & {
'data'?: MediaRecentListFullResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerGetLinkToFile()` */
  static readonly MediaControllerGetLinkToFilePath = '/file-manager/link';

  /**
   * Restituisce un indirizzo temporaneo per il file richiesto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerGetLinkToFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetLinkToFile$Response(params: MediaControllerGetLinkToFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaLinkResponse;
}>> {
    const obs = mediaControllerGetLinkToFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce un indirizzo temporaneo per il file richiesto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerGetLinkToFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetLinkToFile(params: MediaControllerGetLinkToFile$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaLinkResponse;
}> {
    const resp = this.mediaControllerGetLinkToFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaLinkResponse;
}>): BaseResponse & {
'data'?: MediaLinkResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerListFilesAndFolders()` */
  static readonly MediaControllerListFilesAndFoldersPath = '/file-manager/file';

  /**
   * Restituisce l'elenco dei media nel bucket a partire dal prefix (cartella) fornito.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerListFilesAndFolders()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerListFilesAndFolders$Response(params?: MediaControllerListFilesAndFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaListFullResponse;
}>> {
    const obs = mediaControllerListFilesAndFolders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco dei media nel bucket a partire dal prefix (cartella) fornito.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerListFilesAndFolders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerListFilesAndFolders(params?: MediaControllerListFilesAndFolders$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaListFullResponse;
}> {
    const resp = this.mediaControllerListFilesAndFolders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaListFullResponse;
}>): BaseResponse & {
'data'?: MediaListFullResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerListFolders()` */
  static readonly MediaControllerListFoldersPath = '/file-manager/folder';

  /**
   * Restituisce l'elenco non ricorsivo dei prefixes (cartelle) nel bucket a partire dal prefix fornito.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerListFolders()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerListFolders$Response(params: MediaControllerListFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaListPrefixResponse;
}>> {
    const obs = mediaControllerListFolders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco non ricorsivo dei prefixes (cartelle) nel bucket a partire dal prefix fornito.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerListFolders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerListFolders(params: MediaControllerListFolders$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaListPrefixResponse;
}> {
    const resp = this.mediaControllerListFolders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaListPrefixResponse;
}>): BaseResponse & {
'data'?: MediaListPrefixResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerGetUrl()` */
  static readonly MediaControllerGetUrlPath = '/file-manager/url/{name}';

  /**
   * Genera l'URL per accedere al media.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerGetUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetUrl$Response(params: MediaControllerGetUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaUrlResponse;
}>> {
    const obs = mediaControllerGetUrl(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Genera l'URL per accedere al media.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerGetUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetUrl(params: MediaControllerGetUrl$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaUrlResponse;
}> {
    const resp = this.mediaControllerGetUrl$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaUrlResponse;
}>): BaseResponse & {
'data'?: MediaUrlResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerDeleteFile()` */
  static readonly MediaControllerDeleteFilePath = '/file-manager/delete';

  /**
   * Elimina un file o una cartella.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerDeleteFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerDeleteFile$Response(params: MediaControllerDeleteFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeletedItem;
}>> {
    const obs = mediaControllerDeleteFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Elimina un file o una cartella.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerDeleteFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerDeleteFile(params: MediaControllerDeleteFile$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: DeletedItem;
}> {
    const resp = this.mediaControllerDeleteFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: DeletedItem;
}>): BaseResponse & {
'data'?: DeletedItem;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerMoveFile()` */
  static readonly MediaControllerMoveFilePath = '/file-manager/move';

  /**
   * Sposta un file da un percorso ad un altro.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerMoveFile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerMoveFile$Response(params: MediaControllerMoveFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovedItem;
}>> {
    const obs = mediaControllerMoveFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sposta un file da un percorso ad un altro.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerMoveFile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerMoveFile(params: MediaControllerMoveFile$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MovedItem;
}> {
    const resp = this.mediaControllerMoveFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MovedItem;
}>): BaseResponse & {
'data'?: MovedItem;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerDownload()` */
  static readonly MediaControllerDownloadPath = '/file-manager/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerDownload()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerDownload$Response(params: MediaControllerDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = mediaControllerDownload(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerDownload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerDownload(params: MediaControllerDownload$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.mediaControllerDownload$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mediaControllerMakeDir()` */
  static readonly MediaControllerMakeDirPath = '/file-manager/mkdir';

  /**
   * Crea una cartella.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerMakeDir()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerMakeDir$Response(params: MediaControllerMakeDir$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FolderCreationResponse;
}>> {
    const obs = mediaControllerMakeDir(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea una cartella.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerMakeDir$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerMakeDir(params: MediaControllerMakeDir$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: FolderCreationResponse;
}> {
    const resp = this.mediaControllerMakeDir$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: FolderCreationResponse;
}>): BaseResponse & {
'data'?: FolderCreationResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaControllerUploadFile()` */
  static readonly MediaControllerUploadFilePath = '/file-manager';

  /**
   * Carica un file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerUploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mediaControllerUploadFile$Response(params: MediaControllerUploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UploadedItem;
}>> {
    const obs = mediaControllerUploadFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Carica un file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerUploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mediaControllerUploadFile(params: MediaControllerUploadFile$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UploadedItem;
}> {
    const resp = this.mediaControllerUploadFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UploadedItem;
}>): BaseResponse & {
'data'?: UploadedItem;
} => r.body)
    );
  }

}
